import { render, staticRenderFns } from "./ConfigurationTestSummaryModal.vue?vue&type=template&id=16c946d4"
import script from "./ConfigurationTestSummaryModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfigurationTestSummaryModal.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports